__turbopack_context__.v({
  "blok-big-title": "NeedlePicker-module__Xqj5Rq__blok-big-title",
  "blok-subtitle": "NeedlePicker-module__Xqj5Rq__blok-subtitle",
  "blok-title": "NeedlePicker-module__Xqj5Rq__blok-title",
  "showMoreBtn": "NeedlePicker-module__Xqj5Rq__showMoreBtn",
});
